import React, { useEffect, useState } from "react";

// CSS
import "./button.css";

// Components
import GetSvgIcon from "../../SvgIcons/SvgIcon";

// Functions and hooks
import useNarrowMode from "../../hooks/useNarrowModeChecker";

export default function Button({
  onClick,
  btnStyle,
  btnSize,
  btnMargin,
  btnBehaviour,
  children,
  disabled,
  acceptEnter = false,
  className = "",
  icon = "none",
  hapticsEnabled = true,
  tutorialId,
}) {
  const [IconComponent, setIconComponent] = useState();
  const isNarrow = useNarrowMode();

  useEffect(() => {
    if (icon !== "none") {
      const newIconComponent = GetSvgIcon(icon);
      setIconComponent(() => newIconComponent);
    } else {
      setIconComponent(null);
    }
  }, [icon]);

  const STYLES = [
    "btn-primary",
    "btn-negative",
    "btn-positive",
    "btn-disabled",
  ];
  const SIZES = ["btn-normal", "btn-small", "btn-large"];
  const BEHAVIOURS = ["", "btn-fill", "btn-square", "btn-fit"];
  const MARGINS = ["", "btn-small", "btn-default"];

  const checkButtonStyle = disabled
    ? STYLES[3]
    : STYLES.includes(btnStyle)
    ? btnStyle
    : STYLES[0];
  const checkButtonSize = SIZES.includes(btnSize) ? btnSize : SIZES[0];
  const checkButtonBehaviour = BEHAVIOURS.includes(btnBehaviour)
    ? btnBehaviour
    : BEHAVIOURS[0];
  const checkButtonMargin = MARGINS.includes(btnMargin)
    ? btnMargin
    : MARGINS[0];

  const marginValues = {
    btnsmall: isNarrow ? " 0 mr-3 0 ml-3 " : "m-1",
    btndefault: isNarrow ? " mt-8 mr-8 0 ml-8 " : "m-8",
  };
  const marginValue = marginValues[checkButtonMargin.replace("-", "")];

  useEffect(() => {
    const handleEnterPress = (event) => {
      if (
        event.key === "Enter" &&
        acceptEnter &&
        checkButtonStyle !== "btn-disabled"
      ) {
        if (hapticsEnabled && navigator.vibrate) navigator.vibrate(50);
        onClick();
      }
    };

    window.addEventListener("keydown", handleEnterPress);
    return () => {
      window.removeEventListener("keydown", handleEnterPress);
    };
  }, [onClick, checkButtonStyle, hapticsEnabled]);

  const handleClick = (e) => {
    if (hapticsEnabled && navigator.vibrate) {
      if (navigator.vibrate) navigator.vibrate(1);
      console.log("Vibrated");
    }
    onClick?.(e);
  };

  return (
    <button
      className={
        `btn icon-animate-parent ${checkButtonStyle} ${checkButtonSize} ${checkButtonBehaviour}` +
        " radius-s boxShadow-default " +
        marginValue +
        " " +
        className
      }
      disabled={checkButtonStyle === "btn-disabled"}
      data-tutorial-id={tutorialId}
      onClick={handleClick}
      style={{
        ...(IconComponent && children
          ? { gridTemplateColumns: "1fr 3fr 1fr", justifyContent: "start" }
          : { justifyContent: "center", display: "flex" }),
      }}
    >
      {IconComponent && (
        <IconComponent
          className={children ? "ml-1" : ""}
          style={{ color: "inherit", height: "60%" }}
        />
      )}
      {children ? <div className="btn-text">{children}</div> : null}
    </button>
  );
}
